import Card from 'app/components/Card'
import { Skeleton } from 'app/components/Skeleton'
import React from 'react'

const ColumnLoading = () => {
  return (
    <Card className="rounded-[6px] !p-[10px] min-h-[140px] h-[140px] ">
        <div className="flex flex-col justify-between items-center  h-full">
          {Array.from({ length: 4 }).map((_, i) => (
            <div
              key={i}
              className="flex flex-row items-center justify-between gap-2 h-[20px] "
            >
              <Skeleton className="h-[16px] w-[225px] " />
            </div>
          ))}
        </div>
      </Card>
  )
}

export default ColumnLoading
